import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons'
import { Card } from 'antd'
import { useTranslation } from 'next-i18next'
import Button from './Button'

const CARD_ITEMS_1 = [
  {
    key: 'card_items.item1',
    checked: true,
  },
  {
    key: 'card_items.item2',
    checked: true,
  },
  {
    key: 'card_items.item3',
    checked: true,
  },
  {
    key: 'card_items.item4',
    checked: true,
  },
  {
    key: 'card_items.item5',
    checked: true,
  },
  {
    key: 'card_items.item6',
    checked: true,
  },
]

const Intro = ({
  loading = false,
  onBack = () => '',
  onContinue = () => '',
}) => {
  const { t } = useTranslation('application-intro')

  return (
    <div className="flex flex-col gap-y-4 items-center justify-center py-10 md:gap-y-10 md:py-24">
      <h1 className="text-white text-3xl font-semibold md:text-4xl text-center max-w-3xl leading-tight mb-4">
        {t('title')}
      </h1>
      <h2 className="text-white text-center text-lg md:text-xl">
        {t('subtitle')} {/* Subtitle translation */}
      </h2>
      <Button
        loading={loading}
        color="secondary"
        onClick={onContinue}
        className="animate-pulse-animation"
      >
        {t('button_continue_up')} {/* Translated "Continue" */}
      </Button>
      <div className="flex flex-col gap-6 lg:flex-row">
        <IntroCard
          title={t('card_title')} // Translated title for the card
          items={CARD_ITEMS_1}
        />
      </div>
      <div className="flex gap-x-4">
        <Button variant="outlined" color="secondary" onClick={onBack}>
          {t('button_back')} {/* Translated "Back to homepage" */}
        </Button>
        <Button loading={loading} color="secondary" onClick={onContinue}>
          {t('button_continue')} {/* Translated "Continue" */}
        </Button>
      </div>
    </div>
  )
}

const IntroCard = ({ title, items = [] }) => {
  const { t } = useTranslation('application-intro')
  return (
    <Card className="rounded-3xl font-inter max-w-[525px]">
      <span className="text-2xl text-g400 font-semibold md:text-4xl">
        {title}
      </span>
      <ul className="mt-6 flex flex-col gap-y-6">
        {items.map((item) => {
          return (
            <li key={item.key} className="flex items-center gap-x-2">
              {item.checked ? (
                <CheckCircleFilled className="text-g500 text-2xl" />
              ) : (
                <CloseCircleFilled className="text-[#FF6666] text-2xl" />
              )}
              {/* Ensure the correct key is passed here */}
              <span className="text-g400">{t(item.key)}</span>
            </li>
          )
        })}
      </ul>
    </Card>
  )
}

export default Intro
